import { render, staticRenderFns } from "./SalesTarget.vue?vue&type=template&id=60560afe&scoped=true&"
import script from "./SalesTarget.vue?vue&type=script&lang=ts&"
export * from "./SalesTarget.vue?vue&type=script&lang=ts&"
import style0 from "./SalesTarget.vue?vue&type=style&index=0&id=60560afe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60560afe",
  null
  
)

export default component.exports